/* Complete directory controller. OR within a filter; AND between filters. */
(function () {
  'use strict';

  const list = v =>
    Array.isArray(v)
      ? v.map(String).map(x => x.trim()).filter(Boolean)
      : v == null || v === ''
        ? []
        : [String(v).trim()];

  const esc = v =>
    String(v ?? '').replace(
      /[&<>"']/g,
      c =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[c]
    );

  const truth = v =>
    v === true ||
    ['true', '1', 'yes', 'y', 'checked'].includes(
      String(v).toLowerCase()
    );

  const slug = v =>
    String(v)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

  const fields = {
    category: 'pathway',
    industries: 'industry',
    audience: 'audience',
    serviceArea: 'state',
    cost: 'cost',
    apprenticeshipType: 'apprenticeship_type'
  };

  const aliases = {
    category: 'pathway',
    service_area: 'state',
    location: 'state',
    women_focused: 'women'
  };

  const pathwayTokens = {
    'Scholarships & Funding': 'scholarships',
    'Education & Training': 'education-training',
    'Pre-Apprenticeships': 'pre-apprenticeships',
    'Apprenticeships': 'apprenticeships',
    'Mentorship & Hands-On Programs': 'mentorship'
  };

  const states = {
    Arizona: 'AZ',
    California: 'CA',
    'New York': 'NY',
    Texas: 'TX',
    Washington: 'WA',
    Florida: 'FL',
    Illinois: 'IL',
    Massachusetts: 'MA',
    Colorado: 'CO',
    Oregon: 'OR',
    Ohio: 'OH',
    Pennsylvania: 'PA',
    Michigan: 'MI',
    Georgia: 'GA',
    'North Carolina': 'NC',
    Virginia: 'VA',
    Alabama: 'AL',
    Alaska: 'AK',
    Arkansas: 'AR',
    Connecticut: 'CT',
    Delaware: 'DE',
    Hawaii: 'HI',
    Idaho: 'ID',
    Indiana: 'IN',
    Iowa: 'IA',
    Kansas: 'KS',
    Kentucky: 'KY',
    Louisiana: 'LA',
    Maine: 'ME',
    Maryland: 'MD',
    Minnesota: 'MN',
    Mississippi: 'MS',
    Missouri: 'MO',
    Montana: 'MT',
    Nebraska: 'NE',
    Nevada: 'NV',
    'New Hampshire': 'NH',
    'New Jersey': 'NJ',
    'New Mexico': 'NM',
    'North Dakota': 'ND',
    Oklahoma: 'OK',
    'Rhode Island': 'RI',
    'South Carolina': 'SC',
    'South Dakota': 'SD',
    Tennessee: 'TN',
    Utah: 'UT',
    Vermont: 'VT',
    'West Virginia': 'WV',
    Wisconsin: 'WI',
    Wyoming: 'WY',
    'District of Columbia': 'DC'
  };

  function token(field, value) {
    return field === 'category'
      ? pathwayTokens[value] || slug(value)
      : field === 'serviceArea'
        ? states[value] ||
          (/^[A-Z]{2}$/.test(value) ? value : slug(value))
        : slug(value);
  }

  function init(root) {
    if (root.dataset.mymReady) return;
    root.dataset.mymReady = 'true';

    const $ = s => root.querySelector(s);
    const $$ = s => Array.from(root.querySelectorAll(s));

    const preview = root.dataset.previewMode === 'true';

    let raw = [];

    try {
      raw = preview
        ? window.MYM_PREVIEW_RESOURCES || []
        : JSON.parse(
            document.getElementById(
              'mym-resources-data-' + root.dataset.sectionId
            ).textContent
          );
    } catch (e) {
      console.error('[MYM] Resource data could not be loaded', e);
    }

    const resources = raw
      .map(r => ({
        ...r,
        slug: r.slug || r.handle || r.websiteSlug,
        name: r.name || r.programName || r.program_name,
        shortDescription:
          r.shortDescription || r.short_description || '',
        category: list(r.category || r.categories).filter(
          c => c !== 'Explore Careers'
        ),
        industries: list(r.industries),
        audience: list(
          r.audienceNew || r.audience_new || r.audience
        ),
        serviceArea: list(r.serviceArea || r.service_area),
        cost: list(r.cost),
        apprenticeshipType: list(
          r.apprenticeshipType || r.apprenticeship_type
        ),
        womenFocused: truth(
          r.womenFocused ?? r.women_focused
        ),
        featured: truth(r.featured)
      }))
      .filter(r => r.name && r.slug)
      .sort((a, b) => a.name.localeCompare(b.name));

    const order = [
      'Education & Training',
      'Pre-Apprenticeships',
      'Apprenticeships',
      'Mentorship & Hands-On Programs',
      'Scholarships & Funding'
    ];

    $$('[data-mym-dynamic-options]').forEach(container => {
      const field = container.dataset.mymDynamicOptions;

      const counts = new Map();

      resources.forEach(r =>
        new Set(list(r[field])).forEach(v =>
          counts.set(v, (counts.get(v) || 0) + 1)
        )
      );

      const values = [...counts.keys()].sort((a, b) =>
        field === 'category'
          ? (order.indexOf(a) < 0 ? 99 : order.indexOf(a)) -
              (order.indexOf(b) < 0 ? 99 : order.indexOf(b)) ||
            a.localeCompare(b)
          : a.localeCompare(b)
      );

      container.innerHTML = values
        .map(
          (v, i) =>
            '<label class="mym-filter-option">' +
            '<input type="checkbox" data-field="' +
            field +
            '" value="' +
            esc(v) +
            '">' +
            '<span class="mym-filter-option__box" aria-hidden="true"></span>' +
            '<span class="mym-filter-option__text">' +
            esc(v) +
            '</span>' +
            '<span class="mym-filter-option__count">' +
            counts.get(v) +
            '</span>' +
            '</label>'
        )
        .join('');
    });

    const search = $('[data-mym-search]');
    const women = $('[data-mym-women]');
    const checks = $$('input[data-field]');

    let page = 1;
    let timer;

    const pageSize = 24;

    function restore() {
      const p = new URLSearchParams(location.search);

      Object.entries(aliases).forEach(([old, key]) => {
        if (!p.has(key)) {
          p.getAll(old).forEach(v => p.append(key, v));
        }
      });

      search.value = p.get('q') || '';
      women.checked = truth(p.get('women'));
      page = Math.max(
        1,
        parseInt(p.get('resource_page'), 10) || 1
      );

      checks.forEach(c => {
        const values = p
          .getAll(fields[c.dataset.field])
          .flatMap(v => v.split(','));

        c.checked = values.some(
          v =>
            slug(v) === slug(c.value) ||
            slug(v) === slug(token(c.dataset.field, c.value))
        );

        if (c.checked) {
          c.closest('details').open = true;
        }
      });
    }

    function remember() {
      try {
        sessionStorage.setItem(
          'mym-directory-return',
          location.pathname + location.search
        );
      } catch (e) {}
    }

    function write(mode) {
      const u = new URL(location.href);

      [
        ...Object.values(fields),
        ...Object.keys(aliases),
        'q',
        'women',
        'resource_page'
      ].forEach(k => u.searchParams.delete(k));

      if (search.value.trim()) {
        u.searchParams.set('q', search.value.trim());
      }

      checks
        .filter(c => c.checked)
        .forEach(c =>
          u.searchParams.append(
            fields[c.dataset.field],
            token(c.dataset.field, c.value)
          )
        );

      if (women.checked) {
        u.searchParams.set('women', '1');
      }

      if (page > 1) {
        u.searchParams.set(
          'resource_page',
          String(page)
        );
      }

      if (u.href !== location.href) {
        history[
          mode === 'replace'
            ? 'replaceState'
            : 'pushState'
        ](
          null,
          '',
          u.pathname + u.search + u.hash
        );
      }

      remember();
    }

    function foot(label, value) {
      return (
        '<div class="mym-card__foot-item">' +
        '<span class="mym-card__foot-label">' +
        label +
        '</span>' +
        '<span class="mym-card__foot-value">' +
        esc(value || 'Not specified') +
        '</span>' +
        '</div>'
      );
    }

    function card(r) {
      return (
        '<a class="mym-card' +
        (r.featured ? ' is-featured' : '') +
        '" href="/pages/resources/' +
        encodeURIComponent(r.slug) +
        '"' +
        (preview
          ? ' aria-disabled="true" title="Preview data: publish the resource before opening its page"'
          : '') +
        '>' +
        (r.featured
          ? '<span class="mym-card__badge">Featured</span>'
          : '') +
        '<div class="mym-card__title-group">' +
        '<p class="mym-card__pathway">' +
        esc(r.category.join(' · ')) +
        '</p>' +
        '<div class="mym-card__head">' +
        '<h3 class="mym-card__title">' +
        esc(r.name) +
        '</h3>' +
        (r.womenFocused
          ? '<span class="mym-card__women">Women</span>'
          : '') +
        '</div>' +
        '</div>' +
        '<p class="mym-card__desc">' +
        esc(r.shortDescription) +
        '</p>' +
        '<div class="mym-card__foot">' +
        foot("Who it's for", r.audience.join(', ')) +
        foot('Location', r.serviceArea.join(' · ')) +
        foot('Cost', r.cost.join(', ')) +
        '</div>' +
        '<div class="mym-card__learn">Learn more →</div>' +
        '</a>'
      );
    }

    function render() {
      const selection = {};

      checks
        .filter(c => c.checked)
        .forEach(
          c =>
            (selection[c.dataset.field] ??= []).push(
              c.value
            )
        );

      const apprentice =
        selection.category?.includes(
          'Apprenticeships'
        );

      $('[data-mym-apprenticeship-group]').hidden =
        !apprentice &&
        !selection.apprenticeshipType;

      const query = search.value
        .trim()
        .toLowerCase();

      const matches = resources.filter(
        r =>
          (!women.checked || r.womenFocused) &&
          Object.entries(selection).every(
            ([k, v]) =>
              v.some(x =>
                list(r[k]).includes(x)
              )
          ) &&
          (!query ||
            [
              r.name,
              r.shortDescription,
              r.fullDescription,
              ...r.category,
              ...r.industries,
              ...r.audience,
              ...r.serviceArea,
              ...r.cost
            ]
              .join(' ')
              .toLowerCase()
              .includes(query))
      );

      /*
       * Featured-first display order:
       * 1. Featured resources first.
       * 2. Non-featured resources second.
       * 3. Existing alphabetical order is preserved
       *    within each group.
       * 4. Applies to default directory, search,
       *    filters, and combined filtering.
       */
      const orderedMatches = [
        ...matches.filter(r => r.featured),
        ...matches.filter(r => !r.featured)
      ];

      const pages = Math.max(
        1,
        Math.ceil(
          orderedMatches.length / pageSize
        )
      );

      page = Math.min(page, pages);

      $('[data-mym-count]').textContent =
        '(' + orderedMatches.length + ')';

      $('[data-mym-empty]').hidden =
        orderedMatches.length > 0;

      $('[data-mym-results]').innerHTML =
        orderedMatches
          .slice(
            (page - 1) * pageSize,
            page * pageSize
          )
          .map(card)
          .join('');

      const button = (
        label,
        n,
        disabled,
        current
      ) =>
        '<button type="button" class="mym-page" data-page="' +
        n +
        '"' +
        (disabled ? ' disabled' : '') +
        (current
          ? ' aria-current="page"'
          : '') +
        '>' +
        label +
        '</button>';

      let html = '';

      if (pages > 1) {
        html = button(
          'Prev',
          page - 1,
          page === 1,
          false
        );

        let previous = 0;

        for (let i = 1; i <= pages; i++) {
          if (
            i === 1 ||
            i === pages ||
            Math.abs(i - page) <= 1
          ) {
            if (
              previous &&
              i - previous > 1
            ) {
              html +=
                '<span class="mym-page--gap">…</span>';
            }

            html += button(
              i,
              i,
              false,
              i === page
            );

            previous = i;
          }
        }

        html += button(
          'Next',
          page + 1,
          page === pages,
          false
        );
      }

      $('[data-mym-pagination]').innerHTML =
        html;
    }

    function change(mode) {
      page = 1;
      render();
      write(mode);
    }

    root.addEventListener(
      'change',
      e => {
        if (
          e.target.matches(
            'input[type="checkbox"]'
          )
        ) {
          change();
        }
      }
    );

    search.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(
        () => change('replace'),
        180
      );
    });

    $('[data-mym-search-submit]').addEventListener(
      'click',
      () => {
        clearTimeout(timer);
        change();
      }
    );

    search.addEventListener(
      'keydown',
      e => {
        if (e.key === 'Enter') {
          e.preventDefault();
          clearTimeout(timer);
          change();
        }
      }
    );

    $$(
      '[data-mym-clear],[data-mym-mobile-clear]'
    ).forEach(b =>
      b.addEventListener('click', () => {
        clearTimeout(timer);

        checks.forEach(
          c => (c.checked = false)
        );

        search.value = '';
        women.checked = false;

        change();
      })
    );

    root.addEventListener(
      'click',
      e => {
        const b = e.target.closest(
          '[data-page]'
        );

        if (b && !b.disabled) {
          page = Number(b.dataset.page);
          render();
          write();

          $('[data-mym-results]').scrollIntoView({
            block: 'start'
          });
        }

        if (
          e.target.closest('.mym-card')
        ) {
          if (preview) {
            e.preventDefault();
          } else {
            clearTimeout(timer);
            render();
            write('replace');
            remember();
          }
        }
      }
    );

    window.addEventListener(
      'popstate',
      () => {
        clearTimeout(timer);
        restore();
        render();
        remember();
      }
    );

    const panel = $(
      '[data-mym-filter-panel]'
    );

    const toggle = $(
      '[data-mym-filter-toggle]'
    );

    const overlay = $(
      '[data-mym-filter-overlay]'
    );

    function drawer(open) {
      panel.classList.toggle(
        'is-open',
        open
      );

      toggle.setAttribute(
        'aria-expanded',
        String(open)
      );

      overlay.hidden = !open;

      document.body.classList.toggle(
        'mym-filter-drawer-open',
        open
      );

      if (open) {
        panel.setAttribute(
          'role',
          'dialog'
        );

        panel.setAttribute(
          'aria-modal',
          'true'
        );

        panel
          .querySelector('button')
          .focus();
      } else {
        panel.removeAttribute('role');
        panel.removeAttribute(
          'aria-modal'
        );

        toggle.focus();
      }
    }

    toggle.addEventListener(
      'click',
      () =>
        drawer(
          !panel.classList.contains(
            'is-open'
          )
        )
    );

    overlay.addEventListener(
      'click',
      () => drawer(false)
    );

    $$(
      '[data-mym-filter-close]'
    ).forEach(b =>
      b.addEventListener(
        'click',
        () => drawer(false)
      )
    );

    panel.addEventListener(
      'keydown',
      e => {
        if (e.key === 'Escape') {
          drawer(false);
        }

        if (e.key === 'Tab') {
          const focusables = [
            ...panel.querySelectorAll(
              'button,input,summary'
            )
          ].filter(
            el =>
              el.getClientRects().length
          );

          const first = focusables[0];
          const last =
            focusables.at(-1);

          if (
            e.shiftKey &&
            document.activeElement === first
          ) {
            e.preventDefault();
            last.focus();
          } else if (
            !e.shiftKey &&
            document.activeElement === last
          ) {
            e.preventDefault();
            first.focus();
          }
        }
      }
    );

    matchMedia(
      '(max-width:900px)'
    ).addEventListener(
      'change',
      e => {
        if (
          !e.matches &&
          panel.classList.contains(
            'is-open'
          )
        ) {
          drawer(false);
        }
      }
    );

    restore();
    render();
    remember();
  }

  const boot = () =>
    document
      .querySelectorAll(
        '[data-mym-directory]'
      )
      .forEach(init);

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      boot
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    boot
  );
})();